<template>
  <gh-table-page ref="table" :show-tabs="false" :args-query="args" module="mes.business.mon.inventory.service"
    :sort-by="Id" cls="InventoryService">
    <template #area_query>
      <v-layout row align-center>
        <v-flex xs6 lg4>
          <v-text-field v-model="args.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @change="$refs.table.query()">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
  </gh-table-page>

</template>

<style scoped>

</style>

<script>
  import Inventory from "./inventory.ts";
  export default Inventory;
</script>